import type { ShippingPosition } from './types';
import { formatMoney } from './formatMoney';
import { loadOperatorCurrency } from '../currency';

/**
 * The pre-checkout fee rows shown before a delivery address exists: the
 * shipping fee can't be quoted without an address (muted "TBD at Checkout"),
 * and the flat handling fee is backend-sourced (a muted "…" placeholder until
 * it loads). Shared by the reveal Create Shipping modal and the MyPacks ship
 * Disclaimer so the two stay byte-identical.
 *
 * `formatMoney` reads `operator_currency` from sessionStorage on its own.
 * When the currency isn't loaded yet, the handling row falls back to a
 * muted placeholder.
 */
export function buildPreCheckoutPositions(handlingFee: number | null): ShippingPosition[] {
  const hasCurrency = !!loadOperatorCurrency();
  return [
    { label: 'Shipping fee', value: 'TBD at Checkout', muted: true },
    handlingFee != null && hasCurrency
      ? { label: 'Handling fee', value: formatMoney(handlingFee) }
      : { label: 'Handling fee', value: '…', muted: true },
  ];
}
